import { round } from "./index"

export default items => {
    return round(
        items.reduce(
            (total, item) => (total += parseFloat(item.price * item.quantity)),
            0
        ),
        2
    )
}
